import script from "./UIBtnPrimary.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIBtnPrimary.vue?vue&type=script&lang=ts&setup=true"

import "./UIBtnPrimary.vue?vue&type=style&index=0&id=c5f66396&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5f66396"]])

export default __exports__